import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES } from '../../actions/get';

import { Box } from '@/elements';
import {
  getFiltersFromSearchParams,
  setFilterParamsToSearchParams,
  setSortParamsToSearchParams,
} from '@/utils';
import { useSearchParams } from 'react-router-dom';
import {
  getVariables,
  queryParamsInitial,
  instructionTypeForFilter,
  setSearchParamsToState,
} from './store';
import UserTable from './components/userTable';
import { UserHeader } from '@/common/pages/users/components/userHeader/index.jsx';

const Users = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState({
    ...queryParamsInitial,
    filters: getFiltersFromSearchParams(Object.fromEntries([...searchParams])),
  });

  const [getFilter, { data, loading }] = useLazyQuery(GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES);

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, queryParamsInitial);
  }, [searchParams]);

  useEffect(() => {
    getData();
  }, [queryParams]);

  const getData = () =>
    getFilter({ variables: getVariables(queryParams, instructionTypeForFilter) });

  const onPageChange = (page, size) => {
    searchParams.set('page', String(page));
    searchParams.set('limit', String(size));

    setSearchParams(searchParams, { replace: true });
  };

  const onSortingChange = (sortArray) => {
    searchParams.set('page', String(queryParams.page));

    setSortParamsToSearchParams(sortArray, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  const onFiltersChange = (filterList) => {
    searchParams.set('page', String(queryParams.page));

    setFilterParamsToSearchParams(filterList, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  return (
    <Box width="100%">
      <Box padding="35px" gap="40px" direction="column" width="100%">
        <UserHeader setSearchParams={setSearchParams} searchParams={searchParams} />

        <UserTable
          data={data?.partnerClientAccountEmployees?.items || []}
          onPageChange={onPageChange}
          onSortingChange={onSortingChange}
          onFiltersChange={onFiltersChange}
          totalPages={data?.partnerClientAccountEmployees?.info?.totalPages || 1}
          totalCount={data?.partnerClientAccountEmployees?.info?.totalCount || 0}
          loading={loading}
          queryParams={queryParams}
        />
      </Box>
    </Box>
  );
};

export default Users;
